<div>
    <app-vwsa-text weight="bold" text="Vehicle Details"></app-vwsa-text>
    <br />
    <div class="column__list">
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-vehicleModel" label="Vehicle Model" value="{{selectedVehicleDetail?.modelName}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-modelYear" label="Model Year" value="{{selectedVehicleDetail?.year}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-odometer" label="Odometer Reading" value="{{selectedVehicleDetail?.currentOdometer}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-modelCode" label="Model Code" value="{{selectedVehicleDetail?.modelNumber}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-modelDescription" label="Model Description" value="{{selectedVehicleDetail?.modelDescription}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-deliveryDate" label="Delivery Date" value="{{selectedVehicleDetail?.deliveryDate | date:'dd MMMM yyyy'}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-vin" label="VIN Number" value="{{selectedVehicleDetail?.vin}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-engineNumber" label="Engine Number" value="{{selectedVehicleDetail?.engineNumber}}" disabled="true">
            </app-vwsa-text-input>
        </div>
    </div>
    <br />
    <app-vwsa-text weight="bold" text="Current Plan Details"></app-vwsa-text>
    <br />
    <div class="column__list">
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-planType" label="Plan Type" value="{{selectedVehicleDetail?.planType}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-planStartDate" label="Plan Start Date" value="{{selectedVehicleDetail?.planStart  | date:'dd MMMM yyyy'}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-planEndDate" label="Plan End Date" value="{{selectedVehicleDetail?.planEnd | date:'dd MMMM yyyy'}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-planStartKM" label="Plan Start KMs" value="{{selectedVehicleDetail?.startKM}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-planEndKM" label="Plan End KMs" value="{{selectedVehicleDetail?.currentPlanEndKM}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-warrantyStatus" label="Warranty" value="{{selectedVehicleDetail?.warrantyStatus}}" disabled="true">
            </app-vwsa-text-input>
        </div>
    </div>
    <br />
    <app-vwsa-text weight="bold" text="New Plan Details"></app-vwsa-text>
    <br />
    <div class="column__list">
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-newPlanType" label="Plan Type" value="{{newPlanOption?.planType}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-newPlanStartDate" label="Plan Start Date" value="{{newPlanOption?.planStartDate | date:'dd MMMM yyyy'}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-newPlanEndDate" label="Plan End Date" value="{{newPlanOption?.planEndDate | date:'dd MMMM yyyy'}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-newPlanStartKM" label="Plan Start KMs" value="{{newPlanOption?.planStartKM}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-newPlanEndKM" label="Plan End KMs" value="{{newPlanOption?.maxKilometers}}" disabled="true">
            </app-vwsa-text-input>
        </div>
    </div>
    <br />
    <app-vwsa-text weight="bold" text="Pricing Details"></app-vwsa-text>
    <br />
    <div class="column__list">
        <div class="card__list">
            <app-vwsa-text-input inputId="view-quote-newPlanPrice" label="Total (incl. VAT)" value="R{{newPlanOption?.price | number}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list"></div>
        <div class="card__list"></div>
    </div>
    <br />
    <app-vwsa-text weight="bold" text="Owner Details"></app-vwsa-text>
    <app-vwsa-text appearance="copy0100" text="(Please update if necessary)"></app-vwsa-text><br />
    <form [formGroup]="viewQuoteOwnerInfoForm">
        <div class="column__list">
            <div class="card__list">
                <app-vwsa-text-input inputId="view-quote-firstName" label="First Name" formControlName="firstName" isRequired="true" (onblur)="onValidateInput('firstName',null)"
                    (valueChange)="onValidateInput('firstName',$event)" validationMessage="{{firstNameValidationMessage}}">
                </app-vwsa-text-input>
            </div>
            <div class="card__list">
                <app-vwsa-text-input inputId="view-quote-lastName" label="Last Name" formControlName="lastName" isRequired="true" (onblur)="onValidateInput('lastName',null)"
                    (valueChange)="onValidateInput('lastName',$event)" validationMessage="{{lastNameValidationMessage}}">
                </app-vwsa-text-input>
            </div>
            <div class="card__list">
                <app-vwsa-text-input inputId="view-quote-mobileNumber" label="Mobile Number" formControlName="mobileNumber" isRequired="false"
                    (onblur)="onValidateInput('mobileNumber',null)" (valueChange)="onValidateInput('mobileNumber',$event)" validationMessage="{{mobileNumberValidationMessage}}">
                </app-vwsa-text-input>
            </div>
            <div class="card__list">
                <app-vwsa-text-input inputId="view-quote-email" label="Email Address" formControlName="emailAddress" isRequired="true"
                    (onblur)="onValidateInput('emailAddress',null)" (valueChange)="onValidateInput('emailAddress',$event)" validationMessage="{{emailAddressValidationMessage}}">
                </app-vwsa-text-input>
            </div>
        </div>
    </form>
    <br />
    <div class="column__list">
        <div class="card__list">
            <app-vwsa-checkbox inputId="view-quote-accept-conditions" label="I accept the terms and conditions and would like to buy now*" [(checked)]="acceptConditions">
            </app-vwsa-checkbox>
        </div>
        <div class="card__list">
            <app-vwsa-button text="View Terms and Conditions" (click)="onViewTermsAndConditions()" variant="secondary">
            </app-vwsa-button>
        </div>
    </div>
    <div>
        <app-vwsa-text appearance="copy0100" text="* Indicates required fields"></app-vwsa-text><br />
        <div style="display: flex;">
            <app-vwsa-button text="Buy Now" (click)="onBuyNow()" [disabled]="!acceptConditions || !viewQuoteOwnerInfoForm.valid">
            </app-vwsa-button>
            <!-- <app-vwsa-button text="Buy Now" (click)="onBuyNow()" [disabled]="!acceptConditions || !viewQuoteOwnerInfoForm.valid || !isPendingContractActivation">
            </app-vwsa-button> -->
            <!-- <app-vwsa-text appearance="copy0100" *ngIf="!this.isPendingContractActivation" style ="padding: 10px;" text="There is a pending contract activation on this vehicle, please allow for up to 24 hours for it to reflect on the system. If you still have any questions or need help with anything, please contact our Customer Care Centre."></app-vwsa-text><br /> -->
        </div>  
    </div>
    <br />
    <div>
        <app-vwsa-button text="Download Quote" (click)="onDownloadQuote()">
        </app-vwsa-button>
    </div>
    <br />
    <app-vwsa-button text="Back" (click)="onBackToCustomizePlan()" variant="secondary"></app-vwsa-button>
    <!--modal for confirming redirect-->
    <p-dialog header="Payment Redirect" [(visible)]="displayRedirectNotice" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
        <p>
            You will be redirected to PayU to make your payment. Please confirm if you want to proceed.
        </p>
        <ng-template pTemplate="footer">
            <app-vwsa-button (click)="displayRedirectNotice=false" text="No"></app-vwsa-button>
            <app-vwsa-button (click)="onProceedToPayment()" text="Yes"></app-vwsa-button>
        </ng-template>
    </p-dialog>
</div>